import { memo } from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const Gear = memo((props: IconProps) => {
    const { color = "var(--header)", ...rest } = props
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={21} height={20} fill="none" viewBox="0 0 20 20" {...rest}>
            <path
                fill={color}
                d="M4.334 2.545A9.99 9.99 0 0 1 7.876.497 3.993 3.993 0 0 0 11 1.999 3.993 3.993 0 0 0 14.124.497a9.99 9.99 0 0 1 3.542 2.048 3.994 3.994 0 0 0 1.47 4.758c.495.339 1.061.561 1.655.651.28 1.349.28 2.741 0 4.09a3.996 3.996 0 0 0-3.389 3.653 3.992 3.992 0 0 0 .264 1.757 9.99 9.99 0 0 1-3.542 2.047A3.994 3.994 0 0 0 11 18a3.993 3.993 0 0 0-3.124 1.502 9.99 9.99 0 0 1-3.542-2.047A3.993 3.993 0 0 0 4.072 14a3.993 3.993 0 0 0-2.863-1.954c-.281-1.35-.281-2.742 0-4.091A3.993 3.993 0 0 0 4.072 6a3.993 3.993 0 0 0 .262-3.454v-.001ZM12.5 12.597a3 3 0 1 0-2.965-5.215 3 3 0 0 0 2.965 5.215Z"
            />
        </svg>
    )
})

export default Gear
